import requests from '../../../../redux/reducer/requests'
import user from '../../../../redux/reducer/user'
import { useDispatch } from 'react-redux'

export default function useFavoritesCallbacks() {
  const dispatch = useDispatch()

  return {
    getFavorites: (pageData) => dispatch(requests.thunks.getFavorites(pageData)),
    addFriend: (id) => dispatch(requests.thunks.addFriend(id)),
    resetFriends: () => dispatch(user.actions.resetFriends()),
    getFriend: (id) => dispatch(requests.thunks.getFriend(id)),
    getUserData: (id) => dispatch(requests.thunks.getUserData(id)),
    setLike: ({ uid, type }) => dispatch(requests.thunks.setLike({ uid, type })),
    setDislike: ({ uid, type }) => dispatch(requests.thunks.setDislike({ uid, type })),
  }
}
